import React, { Component } from 'react';
import PropTypes from 'prop-types';
import CurrencySelectField from './CurrencySelectField';
import CurrencySelectDialog from './CurrencySelectDialog';

class CurrencySelect extends Component {
  state = {
    open: false,
  };

  openCurrencyDialog = () => {
    this.setState({ open: true });
  };

  handleClose = () => {
    this.setState({ open: false });
  };

  render() {
    const {
      label, currency, onChange,
    } = this.props;

    const title = `${label} wählen`;

    return (
      <div>
        <CurrencySelectField
          {...this.props}
          onClick={this.openCurrencyDialog}
          label={title}
        />
        <CurrencySelectDialog
          open={this.state.open}
          title={title}
          onClose={this.handleClose}
          onChange={onChange}
          selectedCurrency={currency.value}
        />
      </div>

    );
  }
}

CurrencySelect.propTypes = {
  id: PropTypes.string.isRequired,
  currency: PropTypes.instanceOf(Object).isRequired,
  label: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default CurrencySelect;



// WEBPACK FOOTER //
// ./src/components/calculator/currency-select/CurrencySelect.js